import React, { useState, useContext } from "react";
import VideoContext from "../../context/video/videoContext";
import "../../styles/fonts.css";
import { subjects } from "../layouts/subjects";

const Filter = (props) => {
  const videoContext = useContext(VideoContext);
  const { filteredVideos } = videoContext;
  const [filter, setFilter] = useState({
    query: "",
    course: null,
    year: null,
    subject: "",
    branch: null,
  });
  const addFilter = (e) => {
    if (e.target.name === "subject") {
      setFilter({ ...filter, [e.target.name]: e.target.value.split("-")[0] });
    } else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  };
  const onFilter = () => {
    filteredVideos(filter);
    setFilter({
      query: "",
      course: null,
      year: null,
      subject: "",
      branch: null,
    });
    props.history.push(`/videos/${filter.query || "*"}`);
  };
  return (
    <form>
      <div className='modal-body'>
        <input
          name='query'
          className='form-control mr-sm-2 simplefont my-2'
          type='search'
          placeholder='Search'
          aria-label='Search'
          onChange={addFilter}
        />
        <fieldset className='form-group'>
          <legend className='fontcool'>Course:</legend>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input border border-dark'
              type='radio'
              name='course'
              id='op1'
              checked={filter.course === "Btech"}
              value='Btech'
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op1'>
              B.Tech.
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='course'
              id='op2'
              value='Msc'
              checked={filter.course === "Msc"}
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op2'>
              M.Sc.
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='course'
              checked={filter.course === "Mtech"}
              id='op3'
              value='Mtech'
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op3'>
              M.Tech.
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='course'
              checked={filter.course === "Phd"}
              id='op4'
              value='Phd'
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op4'>
              Phd
            </label>
          </div>
        </fieldset>

        <fieldset className='form-group'>
          <legend className='fontcool'>Year:</legend>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              id='op1'
              name='year'
              onChange={addFilter}
              checked={filter.year === "1"}
              value='1'
            />
            <label className='form-check-label simplefont' htmlFor='op1'>
              First year
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              id='op2'
              name='year'
              onChange={addFilter}
              checked={filter.year === "2"}
              value='2'
            />
            <label className='form-check-label simplefont' htmlFor='op2'>
              Second Year
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              id='op3'
              name='year'
              onChange={addFilter}
              checked={filter.year === "3"}
              value='3'
            />
            <label className='form-check-label simplefont' htmlFor='op3'>
              Third year
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              id='op4'
              name='year'
              onChange={addFilter}
              checked={filter.year === "4"}
              value='4'
            />
            <label className='form-check-label simplefont' htmlFor='op2'>
              Fourth Year
            </label>
          </div>
        </fieldset>
        <fieldset className='form-group'>
          <legend className='fontcool'>Branch:</legend>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='branch'
              id='op5'
              value='CSE'
              checked={filter.branch === "CSE"}
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op5'>
              Computer Science
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='branch'
              id='op6'
              value='EE'
              checked={filter.branch === "EE"}
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op6'>
              Electrical
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='branch'
              id='op7'
              value='ME'
              checked={filter.branch === "ME"}
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op7'>
              Mechanical
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='branch'
              id='op8'
              checked={filter.branch === "CE"}
              value='CE'
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op8'>
              Civil
            </label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='branch'
              id='op9'
              checked={filter.branch === "MEMS"}
              value='MEMS'
              onChange={addFilter}
            />
            <label className='form-check-label simplefont' htmlFor='op9'>
              Metallurgy
            </label>
          </div>
        </fieldset>
        <div className='form-group'>
          <label htmlFor='subjectList' className='fontcool'>
            Subject
          </label>
          <input
            list='browsers'
            name='subject'
            value={filter.subject}
            id='subjectList'
            onChange={addFilter}
            className='form-control simplefont text-center'
            data-toggle='tooltip'
            data-placement='right'
          />

          <datalist id='browsers'>
            {subjects.BTech.map((item) => (
              <option value={item} key={item} />
            ))}
          </datalist>
        </div>
      </div>
      <div className='modal-footer'>
        <button
          type='button'
          className='btn btn-secondary slantfont'
          data-dismiss='modal'
        >
          Close
        </button>

        <button
          className='btn btn-outline-success my-2 my-sm-0 slantfont'
          type='submit'
          htmlFor='filterform'
          data-dismiss='modal'
          onClick={onFilter}
        >
          Search
        </button>
      </div>
    </form>
  );
};

export default Filter;
